import {
  ChangeDetectionStrategy,
  Component,
  Input,
  ViewEncapsulation,
} from '@angular/core';
import { SharedModule } from '../../../shared.module';
import { WidgetNumberDisplayComponent } from '../widget-number-display/widget-number-display.component';

@Component({
  selector: 'app-widget-orders-display',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  imports: [WidgetNumberDisplayComponent, SharedModule],
  template: `
    <app-widget-number-display
      [status]="'ACTIVE'"
      [number]="orderCount"
      [label]="orderCount || 0 | pluralize: 'Order'"
      [hyperlink]="hyperlink"
      [ctaText]="'View Orders'"
      [navigateOnClick]="navigateOnClick"
      [loading]="loading"
    >
      <div class="relative z-10">
        Spanning {{ locationCount }}
        {{ locationCount | pluralize: 'location' }}
      </div>
    </app-widget-number-display>
  `,
})
export class WidgetOrdersDisplayComponent {
  @Input() loading: boolean = true;

  @Input() hyperlink: string | null = null;

  @Input() navigateOnClick: boolean = false;

  @Input() locationCount: number = 0;

  @Input() orderCount: number = 0;
}
